import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { PureClickDirective } from "../../directives/pure-click.directive";
import { IframeMaximizerComponent } from "./iframe-maximizer.component";

@NgModule({
    declarations: [IframeMaximizerComponent],
    exports: [IframeMaximizerComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, DragDropModule, PureClickDirective]
})
export class IframeMaximizerModule {}
